import React, { FC, useMemo } from 'react';
import { HStack, Text } from '@chakra-ui/react';
import { useMerklUserRewardsByPool } from '@app/hooks/merkl/useMerklUserRewardsByPool';
import { formatUnits } from 'ethers/lib/utils';
import { TokenIcon } from '@app/components/TokenIcon';
import { toOptionalFixed } from '@app/helpers/format';

interface Props {
  pool: string;
  chainIds: number[];
}

export const PoolRewards: FC<Props> = ({ pool, chainIds }) => {
  const { data } = useMerklUserRewardsByPool(pool, chainIds);

  const rewards = useMemo(() => {
    if (!data) {
      return;
    }

    return Object.values(data);
  }, [data]);

  return rewards
    ?.filter(d => d.symbol.toLowerCase() !== 'aglamerkl')
    .map(d => {
      const accum = Object.values(d.reasons).reduce(
        (r, reason) => r + +formatUnits(reason.unclaimed, d.decimals),
        0
      );

      if (accum === 0) {
        return null;
      }

      return (
        <HStack gap={2} alignItems="center" key={d.symbol}>
          <Text fontSize={14} color="neutral.100">
            {d ? toOptionalFixed(accum, 3) : '-'}
          </Text>
          {d && <TokenIcon symbol={d.symbol} />}
        </HStack>
      );
    });
};
